import React from "react";
import {withTranslate} from "react-redux-multilingual";
import {setOffersSkeleton} from "../../skeleton";
import {Link} from "react-router-dom";
import OfferCard from "../../components/offers/OfferCard";
import NoData from "../../components/NoData";


const DynamicOffersArea = ({type,language, translate,loadMore ,offersListIsLoading, offersList, offersLoading, noMoreOffers ,isFilter}) => {
    /* const hsitoryList = history ? history.map((h, index) => {
        return (
            <span key={index} className="mr-2"><a href={h.to}>{h.page}</a></span>
        )
    }) : null; */
    const offersListCards = offersList && offersList.length ? offersList.map((offer, index) => {
        return (
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                 key={index}>
                <Link to={"/offer/" + offer.id}>
                    <OfferCard language={language} offer={offer}/>
                </Link>
            </div>
        )
    }) : (
        <NoData image="no-offers"/>
    );
    return (

        !offersListIsLoading ?
            <div>
                <div className="row" hidden={isFilter}>
                    <div className="col-md-12">
                        <p className="capitalized offer-sponsored-title">{translate('sponsored')}</p>
                    </div>
                </div>
                <div className="row offers-sec p-t-10">
                    {offersListCards}
                    <div className="col-md-12 text-center" hidden={noMoreOffers === true}>
                        <div className="loading-more cursor-pointer"
                             hidden={offersListCards.length < 6 || offersLoading === true}
                        >
                            <div className="text-center">
                                <a href="/" style={{pointerEvents: 'false'}} className="btn"
                                   onClick={(e) => loadMore(e, type)}>{translate("fetch_more")}</a>
                            </div>
                        </div>

                        <div className="loading-more"
                             hidden={offersLoading === false}>
                            <div className="text-center">
                                <img style={{width: '100px'}} src="/images/loading.svg"
                                     alt="loading"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : <div className="row">
                {setOffersSkeleton(10)}
            </div>
    )

};


export default withTranslate(DynamicOffersArea);
